const initState = {
    driver: {},
    auth: false,
  }
  
  const driverReducer = (state = initState, action) => {
    switch (action.type) {
      case 'DRIVER_LOGIN':
        return { ...state, driver: action.payload.data, auth: true };
      case 'DRIVER_LOGIN_ERROR':
        return state;
      default:
        return state;
    }
  
  };
  
  export default driverReducer;